/**
 * /particuliers/aides/eco-ptz
 * ─────────────────────────────────────────────────────────────────
 * Guide éditorial complet (long-form) sur l'éco-prêt à taux zéro.
 *
 * Composé du composant `EcoPtzGuide` (hero, mécanisme, plafonds par
 * type de travaux, travaux éligibles, conditions, démarches, cumul,
 * FAQ, CTA).
 *
 * Contenu factuel : `client/src/config/eco-ptz-content.ts`.
 */

import { EcoPtzGuide } from '../../../../components/aides/EcoPtzGuide';

export default function EcoPtzPage() {
  return <EcoPtzGuide />;
}
